import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-6" }
const _hoisted_2 = ["onSubmit"]
const _hoisted_3 = { class: "grid grid-cols-1 md:grid-cols-3 gap-x-6 gap-y-1" }
const _hoisted_4 = { class: "flex justify-end pt-2" }

import { reactive, ref } from 'vue'
import { ValidationError } from 'yup'
// import { mdiShieldCheckOutline, mdiLaptop } from '@mdi/js'

import GenericInput from '@/components/designSystem/Inputs/GenericInput.vue'
import FilledButton from '@/components/designSystem/Buttons/FilledButton/index.vue'

import SettingsCard from '../atoms/SettingsCard.vue'
// import ComingSoonCard from '../atoms/ComingSoonCard.vue'
import { passwordSchema } from '../../schemas'


export default /*#__PURE__*/_defineComponent({
  __name: 'SecurityPanel',
  props: {
    save: { type: Function }
  },
  setup(__props: any) {

const props = __props;



const saving = ref(false)
const errors = reactive<Record<string, string>>({})

const form = reactive({
  currentPassword: '',
  password: '',
  repeatPassword: ''
})

const clearErrors = () => Object.keys(errors).forEach((key) => delete errors[key])

const reset = () => {
  form.currentPassword = ''
  form.password = ''
  form.repeatPassword = ''
  clearErrors()
}

const handleSubmit = async () => {
  clearErrors()
  try {
    await passwordSchema.validate(form, { abortEarly: false })
  } catch (err) {
    if (err instanceof ValidationError) {
      const inner = err.inner?.length ? err.inner : [err]
      inner.forEach((e) => {
        if (e.path) errors[e.path] = e.message
      })
    }
    return
  }

  saving.value = true
  try {
    await props.save({ password: form.password, repeatPassword: form.repeatPassword })
    reset() // limpa os campos só em sucesso real
  } catch {
    // o pai já exibiu o toast de erro
  } finally {
    saving.value = false
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(SettingsCard, {
      title: "Gerenciar credenciais",
      description: "Use credenciais fortes com ao menos 8 caracteres, incluindo letras e números."
    }, {
      default: _withCtx(() => [
        _createElementVNode("form", {
          class: "flex flex-col gap-4",
          onSubmit: _withModifiers(handleSubmit, ["prevent"])
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(GenericInput, {
              modelValue: form.currentPassword,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.currentPassword) = $event)),
              label: "Credencial atual",
              type: "password",
              required: "",
              "data-testid": "security-current-password-input",
              "error-messages": errors.currentPassword
            }, null, 8, ["modelValue", "error-messages"]),
            _createVNode(GenericInput, {
              modelValue: form.password,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.password) = $event)),
              label: "Nova credencial",
              type: "password",
              required: "",
              "data-testid": "security-new-password-input",
              "error-messages": errors.password
            }, null, 8, ["modelValue", "error-messages"]),
            _createVNode(GenericInput, {
              modelValue: form.repeatPassword,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.repeatPassword) = $event)),
              label: "Confirmar nova credencial",
              type: "password",
              required: "",
              "data-testid": "security-repeat-password-input",
              "error-messages": errors.repeatPassword
            }, null, 8, ["modelValue", "error-messages"])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(FilledButton, {
              text: "Atualizar credenciais",
              width: "180px",
              type: "submit",
              loading: saving.value,
              "data-testid": "security-save-button"
            }, null, 8, ["loading"])
          ])
        ], 40, _hoisted_2)
      ]),
      _: 1
    })
  ]))
}
}

})